class Errors {

    /**
     * Create a new Errors instance.
     */
    constructor() {
        this.errors = {};
    }

    /**
     * Check if provided field has any errors.
     *
     * @param {string} field
     */
    has(field) {
        return this.errors.hasOwnProperty(field);
    }

    /**
     * Check if there are any errors in the form as a whole.
     */
    any() {
        return Object.keys(this.errors).length > 0;
    }

    /**
     * Get the errors for provided field.
     *
     * @param {string} field
     */
    get(field) {
        if (this.errors[field]) {
            return this.errors[field][0];
        }
    }

    /**
     * Set errors for form.
     *
     * @param {object} errors
     */
    set(errors) {
        this.errors = errors;
    }

    /**
     * Remove errors for given field, or remove all errors.
     *
     * @param {string|null} field
     */
    remove(field) {
        if (field) {
            delete this.errors[field];

            return;
        }

        this.errors = {};
    }

    /**
     * Convert the errors to a flat array of error messages.
     */
    toArray() {
        let errorsArray = [];

        Object.keys(this.errors).forEach(key => {
            if (typeof this.errors[key] === 'string') {
                errorsArray.push(this.errors[key]);
                return;
            }

            Object.keys(this.errors[key]).forEach(error => {
                errorsArray.push(this.errors[key][error]);
            });
        });

        return errorsArray;
    }
}

export default Errors;
